import React from 'react';
import './BlogsDashPage.css'; // חיבור קובץ ה-CSS
import BlogDashForm from '../../components/BlogDashForm/BlogDashForm';
import { Link } from "react-router-dom"; // ✅ הוספת הייבוא
const BlogsDash = () => {
  return (
    <div className="blogs-dash-container">
            <div className="ButtonToDash-Button">
        <Link to="/dashboard">
          <button className="ButtonToDashbord">מעבר לדשבורד</button>
        </Link>
      </div>
      <div className='blogs-dash-form'>
        <BlogDashForm />
      </div>
    </div>
  );
};

export default BlogsDash;
